import { useState } from "react";
import { useDispatch } from "react-redux";
import { APPLY_JOB } from "../../Utils/apis";
import { addAppliedJob } from "../../Store/Slices/user";

const useApplyJob = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const applyFunction = async (jobId, screeningAnswers = []) => {
    if (loading) return false;

    try {
      setError("");
      setLoading(true);

      const res = await fetch(APPLY_JOB, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jobId,
          screeningAnswers,
        }),
        credentials: "include",
      });

      const result = await res.json();

      if (!res.ok || result?.success === false) {
        throw new Error(result?.message || "Unable to apply for this job.");
      }

      dispatch(addAppliedJob(jobId));

      return true;
    } catch (error) {
      setError(error.message || "Unable to apply for this job.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return [loading, error, applyFunction];
};

export default useApplyJob;
